import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { forwardRef } from 'react';
import { useAuthorization } from 'framework/authorization';
import { useListContext } from 'framework/list';
import { useShowContext } from 'framework/show';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { Tooltip } from 'framework/ui/mui-builder';
import usePositionSlotsService from '../usePositionSlotsService';
import { POSITION_SLOT_CONFIRM, POSITION_SLOT_STATUS } from '../constants';

const ConfirmTooltipIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({ children, ...props }, ref) => (
  <Tooltip title="Confirm manual assignment">
    <IconButton {...props} ref={ref}>
      {children}
    </IconButton>
  </Tooltip>
));

const ConfirmPositionSlotButton = () => {
  const { isGranted } = useAuthorization();
  const { data } = useShowContext();
  const { reloadData = () => {} } = useListContext();
  const { confirmPositionSlot } = usePositionSlotsService();
  const { id, status } = data.getData();

  if (status !== POSITION_SLOT_STATUS.PENDING || !isGranted(POSITION_SLOT_CONFIRM)) {
    return null;
  }

  return (
    <ButtonWithConfirmation
      buttonTag={ConfirmTooltipIconButton}
      color="transparent"
      displayMessage="Do you really want to confirm this position slot manual assignment?"
      submitMethod={() => confirmPositionSlot(id)}
      permissionToCheck={POSITION_SLOT_CONFIRM}
      afterSubmit={{
        successMessage: 'Position slot has been successfully confirmed.',
        errorMessage: 'Unable to confirm the position slot.',
        execute: () => reloadData(),
      }}
      modalConfirmButtonText="Confirm"
      sx={{
        p: 0,
        minWidth: 'auto',
        width: 'auto !important',
      }}
    >
      <CheckCircleOutlineIcon color="primary" fontSize="small" />
    </ButtonWithConfirmation>
  );
};

export default ConfirmPositionSlotButton;
